
export default {
  name: 'ComCategoryNoData',
  computed: {
    keyword() {
      const query = this.$route.query
      const params = this.$route.params
      if (query.keyword && query.keyword.length) return query.keyword
      if (params.thirdCategory && params.thirdCategory.length)
        return params.thirdCategory
      if (params.secondCategory && params.secondCategory.length)
        return params.secondCategory
      if (params.firstCategory && params.firstCategory.length)
        return params.firstCategory
      return ''
    },
  },
  methods: {
    toIndent() {
      const target = document.getElementById('indentLink')
      if (target) target.click()
    },
  },
}
